import { Prospects } from "../../prospects/Prospects";

/**
 * Visits Tab Component
 * Affiche la liste des visites (prospects) pour un client spécifique en réutilisant le composant principal
 */
const VisitsTab = ({ data }: { data: EasyTech.Customer }) => {
  return <Prospects customer={data} hideHeader={false} hideFilters={false} noPadding={true} />;
};

export default VisitsTab; 